<template>
  <div class="widget-item" :style="style" :class="{ 'non-clickable': isNonClickable }">
    <PlaylistPlayer
      :style="playerStyle"
      :playlist="
        Object.assign(widget.object, {
          imageMode: widget.object.imageMode || widget.position.imageMode,
        })
      "
      :assocId="widget.assoc_id"
    />
  </div>
</template>

<script>
  import playerMixins from '@/models/player';
  import { simpleTypeMixin } from '@/helpers';

  import PlaylistPlayer from '@/components/player/PlaylistPlayer.vue';

  export default {
    name: 'PlaylistWidget',

    mixins: [playerMixins, simpleTypeMixin],

    components: {
      PlaylistPlayer,
    },

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    computed: {
      style() {
        const style = this.defaultStyling(this.widget);

        return style;
      },

      playerStyle() {
        const style = { position: 'relative' };
        if (this.widget.object.border_radius) {
          style.borderRadius = this.widget.object.border_radius + 'px';
        }
        return style;
      },

      isNonClickable() {
        return this.widget.object && this.widget.object.is_non_clickable === true;
      },
    },
  };
</script>

<style scoped lang="scss">
  .widget-item {
    position: absolute;
  }

  .non-clickable {
    pointer-events: none !important;
  }
</style>
